import { render, staticRenderFns } from "./consultationNewShowCell_multilang.vue?vue&type=template&id=58879edf&scoped=true"
import script from "./consultationNewShowCell_multilang.vue?vue&type=script&lang=js"
export * from "./consultationNewShowCell_multilang.vue?vue&type=script&lang=js"
import style0 from "./consultationNewShowCell_multilang.vue?vue&type=style&index=0&id=58879edf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58879edf",
  null
  
)

export default component.exports